import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private config: any;
  public recaptchaSiteKeyV2: string | null = null;

  constructor(
    @Inject(APP_BASE_HREF) private readonly _baseHref: string,
    private readonly _http: HttpClient
  ) {}

  async load(): Promise<void> {
    // Load the configuration file based on the environment
    this.config = await firstValueFrom(
      this._http.get(environment.configFilePath)
    );
    await this.loadReCaptchaConfig();
  }

  private async loadReCaptchaConfig(): Promise<void> {
    const apiBaseUrl = this.get<string>('apiBaseUrl');
    if (!apiBaseUrl) {
      return;
    }
    const url = `${apiBaseUrl}${this.get('RecaptchaConfigUrl')}`;
    const response = await firstValueFrom(this._http.request('get', url));
    this.recaptchaSiteKeyV2 = response as string;
  }

  get<T>(key: string): T {
    return this.config[key] as T;
  }
}
